
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { CityResponse } from "../../models/dtos";

export const citiesApi = createApi({
  reducerPath: 'citiesApi',
  baseQuery: baseAuthQuery('Cities'),
  tagTypes: ['City'],
  endpoints: (builder) => ({
    getCities: builder.query<ApiResponse<CityResponse[]>, void>({
      query: () => "",
      providesTags: ['City'],
    }),
    getCityById: builder.query<ApiResponse<CityResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['City'],
    }),
    updateCity: builder.mutation<ApiResponse<CityResponse>, Partial<CityResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['City'],
    }),
    deleteCity: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['City'],
    }),
  }),
});
